/**
 * User Register Operation
 * Isolated feature: Handle user registration
 */
import { useState, useCallback } from 'react';
import { userService } from '../service';
import type { RegisterRequest } from '../api';

export const useRegister = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const register = useCallback(async (userData: RegisterRequest): Promise<boolean> => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await userService.register(userData);
      setSuccess(true);
      return true;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Registration failed';
      setError(errorMessage);
      return false;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const clearSuccess = useCallback(() => {
    setSuccess(false);
  }, []);

  return {
    register,
    loading,
    error,
    success,
    clearError,
    clearSuccess
  };
};
